import logoIcon from '@/assets/brand/logo_icon.png';
import { APP_NAME } from '@/constants/app.constants';
import { cn } from '@/lib/utils';

interface AppLogoProps {
  className?: string;
}

export function AppLogo({ className }: AppLogoProps) {
  return (
    <span className={cn('flex size-7 shrink-0 items-center justify-center', className)}>
      <img src={logoIcon} alt={APP_NAME} className="size-full object-contain" />
    </span>
  );
}
